import isNaN from 'lodash-es/isNaN';
import { ContentItemType } from './ContentItemType';
import { Mapper, ReadOnly } from 'module/Common';

export type ContentEmbed = ReadOnly<ContentEmbed.Shape>;

export namespace ContentEmbed {
  export interface Shape {
    type: ContentItemType;
    elem: string;
    ratio: number;
    color: string;
    fullWidth: boolean;
  }

  const create = (input: ContentEmbed) => input;

  export const mapper = Mapper.mapSchema(
    {
      acf_fc_layout: Mapper.exact(ContentItemType.Embed),
      elem: Mapper.str,
      ratio: Mapper.str,
      color: Mapper.str,
      full_width: Mapper.bool,
    },
    ({ elem, ratio, color, full_width, acf_fc_layout }) => {
      const ratioArr = ratio.split(':').map(v => parseInt(v, 10));
      const ratioNum = ratioArr.length === 2 ? ratioArr[0] / ratioArr[1] : NaN;
      return create({
        elem,
        color,
        ratio: isNaN(ratioNum) ? 16 / 9 : ratioNum,
        fullWidth: full_width,
        type: acf_fc_layout,
      });
    }
  );

  export const getElem = (model: ContentEmbed): string => model.elem;
  export const getRatio = (model: ContentEmbed): number => model.ratio;
  export const getColor = (model: ContentEmbed): string => model.color;
  export const isFullWidth = (model: ContentEmbed): boolean => model.fullWidth;
}



// WEBPACK FOOTER //
// ./src/module/Model/Content/item/ContentEmbed.ts